export default __webpack_public_path__ + "static/media/summerchallenge10.0550f11c.jpg";